<template>
  <b-container>
    <div class="d-flex flex-row-reverse">
      <b-button size="sm"  @click="goBack()" class="mt-3">
        <i class="fa fa-arrow-left" aria-hidden="true"></i>

      </b-button>
    </div>
    <TicketActivity :activity="activity" :ticket="ticket" class="mb-2 mt-2"/>

    <b-card v-show="ticket.estatus != 'Cerrado'"  class=" shadow mb-2 mt-2 bg-white rounded" :title="'Ticket #'+ticket.id ">
      <b-card-body>
      
          <b-form-group id="input-group-2" label="Comentario:" label-for="comentario">

            <!--
            <b-form-input id="comentario" v-model="dataform.descripcion" name="comentario" v-validate="'required|min:2 '"
              :state="validateState('comentario')" placeholder="Escriba el comentario del ticket"></b-form-input>
            -->

            <b-form-textarea
              id="comentario"
              name="comentario"
              v-model="dataform.descripcion"
              placeholder="Escriba el comentario del ticket"
              rows="5"
              max-rows="8"
              v-validate="'required|min:5 '"
              :state="validateState('comentario')" 

            ></b-form-textarea>
            <b-form-invalid-feedback>
              {{ errors.first('comentario') }}
            </b-form-invalid-feedback>
          </b-form-group>

          <b-form-group
            id="input-group-3"
            label="Estado:"
            label-for="Estado">
            <!--
            <b-form-select
              v-model="dataform.estado"
              :options="options">
            </b-form-select>
            -->

            <b-form-input  
              readonly
              v-model="dataform.estado"
            >

            </b-form-input>
          </b-form-group>
          
          <b-button  
              :disabled="errors.any()" 
              @click="onSubmit"
              variant="primary" 
              class="mb-1"
            >
            Enviar comentario
          </b-button>

          <b-button
              v-if="dataform.estadoId != '4'"
             @click="cerrarTicket"
              variant="success" 
              class="mb-1 ml-1"
          >
            Cerrar ticket
          </b-button>

          <b-button
              v-else
             @click="cerrarTicket"
              variant="success" 
              class="mb-1 ml-1"
              disabled
          >
            Cerrar ticket
          </b-button>
  
      </b-card-body>
      
    </b-card>

  </b-container>
</template>

<script>
  import {mapState,mapActions} from 'vuex'

  import validateMixin from '@/mixins/validation'
  import TicketActivity from '@/components/tickets/TicketActivity.vue'



  export default {
    components:{
     
      TicketActivity,
    }, 
    mixins : [validateMixin],
    data: function(){
      return{
        dataform:{
          ticket_id:'',
          user_id:'',
          descripcion:'',
          estado:'',
          estadoId:'',
        },
        options:[],
      }
    },
    mounted(){this.init()},
    computed:{
      //variable del state que tiene el id del login.
      ...mapState('login',['id']),
      ...mapState('etiquetas',['estados']),
      ...mapState('ticket',['ticket','activity','isOk']),
      },//computed  
    methods:{
      ...mapActions({
      _fetchEstados: 'etiquetas/fetchEstados',
      _crearActividad: 'ticket/crearActividad',
      _cerrarTicket: 'ticket/cerrarTicket'

      }),
      init(){
        this._fetchEstados().then(()=>{
          let that = this//dentro del foreach no usar this.
          this.estados.forEach(function(value){
            if(value.nombre != "Cerrado"){
                let payload = {
                value: value.id,
                text:  value.nombre
              } 
              that.options.push(payload)
              //parte agragada para activar el estado el option boton.
              if(value.nombre === that.ticket.estatus){
                that.dataform.estado = value.nombre
                that.dataform.estadoId = value.id
              }
            }
          })
        })

        this.dataform.user_id = this.id
        this.dataform.ticket_id = this.ticket.id
        
      },//init()
      goBack() {
        this.$router.go(-1)
      },
      async onSubmit(evt){
        evt.preventDefault()
        const validate = await this.$validator.validateAll()
        if(!validate) {return false}
        
        let payload = {
          'ticket_id': this.dataform.ticket_id,
          'user_id': this.dataform.user_id,
          'descripcion' : this.dataform.descripcion,
          'estado' : this.dataform.estadoId //envio el ID del estado
        } 
        this._crearActividad(payload).then(()=>{
           if(this.isOk){
		    			    this.$toasted.show('La actividad se guardo correctamente', { 
	 	    						theme: "bubble", 
	 	    						position: "top-right", 
	 	    						duration : 3000
                            })
                       
                        // volvemos a la pagina anterior
                        this.$router.go(-1) 
                    }else{
                        this.$toasted.show('Error al guardar la actividad del ticket', { 
                  				duration : 3000
                          })
            }  
        })
      },
      /**
       * No se necesita el estado para cerrar por defecto se cierra en 8 en el modelo
       * @param {} evt 
       */
      cerrarTicket(evt){
        evt.preventDefault()
        let payload = {
          'id': this.ticket.id 
        } 
        this._cerrarTicket(payload).then(()=>{
          if(this.isOk){
            this.$toasted.show('El ticket se ha cerrado', { 
	 	    						theme: "bubble", 
	 	    						position: "top-right", 
	 	    						duration : 3000
            })
            this.$router.go(-1) 

          }else{
            this.$toasted.show('Error al cerrar el ticket', { 
                  				duration : 3000
            })
          }
        })
      },

      

    },
  }
</script>

<style lang="scss" scoped>

</style>